import MuiAlert, { type AlertColor, type AlertProps as MuiAlertProps } from '@mui/material/Alert';

export type BootstrapAlertColor =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark';

const SEVERITY: Record<BootstrapAlertColor, AlertColor> = {
  danger: 'error',
  warning: 'warning',
  success: 'success',
  info: 'info',
  primary: 'info',
  secondary: 'info',
  light: 'info',
  dark: 'info',
};

export interface AlertProps extends Omit<MuiAlertProps, 'color' | 'severity'> {
  /** reactstrap color; defaults to 'success' as reactstrap does. */
  color?: BootstrapAlertColor;
  /** An explicit MUI severity wins over `color`. */
  severity?: AlertColor;
  /** reactstrap's dismissible API. */
  isOpen?: boolean;
  toggle?: () => void;
  fade?: boolean;
}

/** MUI Alert with reactstrap's `color` prop, for page and section banners. */
export function Alert({
  color = 'success',
  severity,
  isOpen = true,
  toggle,
  fade: _fade,
  onClose,
  ...rest
}: AlertProps) {
  if (!isOpen) return null;
  return <MuiAlert severity={severity ?? SEVERITY[color]} onClose={onClose ?? toggle} {...rest} />;
}
